import PropTypes from 'prop-types';
import React from 'react';
import {Col, Navbar, Row} from 'react-bootstrap';
import {Link} from 'react-router';
import translate from '../translate';
import Card from '../main/card';

function parseStrongTag(inputText) {
    const result = /^(.*)<strong>(.*)<\/strong>(.*)$/.exec(inputText);
    if (result) {
        return (
            <span>
                {result[1]}
                <strong>{result[2]}</strong>
                {result[3]}
            </span>
        );
    } else {
        return <span>{inputText}</span>;
    }
}

class ReturningPage extends React.Component {
    static propTypes = {
        strings: PropTypes.object,
    };

    componentDidMount() {
        window.close();
    }

    renderCard = () => {
        return (
            <Col xs={6}>
                <Card title={this.props.strings.title}>
                    <div className={'wrap'}>
                        <div
                            style={{
                                marginTop: '1em',
                                marginBottom: '3em',
                                verticalAlign: 'center',
                            }}
                        >
                            {parseStrongTag(this.props.strings.mainText)}
                        </div>
                    </div>
                </Card>
            </Col>
        );
    };

    renderFooter = () => {
        return (
            <div className="footer-wrapper">
                <div className="footer">
                    <div style={{ width: '100%' }} className="container">
                        <Row>
                            <Col
                                xs={6}
                                sm={6}
                                md={6}
                                lg={6}
                                className="pull-right"
                            >
                                <div className="pull-right footer-links">
                                    <Link
                                        to="https://www.we-wash.com/impressum"
                                        target="_blank"
                                    >
                                        {this.props.strings.imprint}
                                    </Link>
                                    <Link
                                        to="https://www.we-wash.com/datenschutz"
                                        target="_blank"
                                    >
                                        {this.props.strings.data}
                                    </Link>
                                </div>
                            </Col>
                            <Col xs={6} sm={6} md={6} lg={6}>
                                <span className="footer-2-copy first">
                                    &copy; WeWash GmbH
                                </span>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        return (
            <div className="site-wrapper">
                <div style={{ display: 'block' }} className="header level-3">
                    <div className="navigation">
                        <div style={{ width: '100%' }} className="container">
                            <Navbar
                                fluid
                                expanded={false}
                                onToggle={() => {}}
                                className="noprr"
                            >
                                <Navbar.Header>
                                    <Link
                                        className={'navbar-brand generic-brand'}
                                        title="WeWash. Shine Bright."
                                    />
                                </Navbar.Header>
                            </Navbar>
                        </div>
                    </div>
                </div>
                <div style={{ width: '100%' }} className="container content">
                    <div className="content-inner">{this.renderCard()}</div>
                </div>
                {this.renderFooter()}
            </div>
        );
    }
}

export default translate('ReturningPage')(ReturningPage);
